module.exports = __webpack_public_path__ + "static/img/wenwu.bf6b0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/wenwu.png
// module id = ne1+
// module chunks = 1